/* eslint-disable no-param-reassign */
import { isCursorInArea } from '../util/isCursorInArea';
import { getColumnAreas } from '../util/getColumnAreas';
import { DragAndDrop } from '../util/DragAndDrop';

export function dragover(event: Event, DragAndDrop: DragAndDrop) {
  const ev = event as DragEvent;
  ev.preventDefault();

  DragAndDrop.timeout = -1;
  if (
    (ev.clientX !== DragAndDrop.dragoverPosition.x ||
      ev.clientY !== DragAndDrop.dragoverPosition.y) &&
    DragAndDrop.draggingPanelId !== '' &&
    DragAndDrop.shadowDiv
  ) {
    DragAndDrop.clearTimeout();
    DragAndDrop.currentBottomPanel = DragAndDrop.findBottomPanel(
      ev.clientX,
      ev.clientY + DragAndDrop.currentScroll,
    );

    DragAndDrop.dragoverPosition.x = ev.clientX;
    DragAndDrop.dragoverPosition.y = ev.clientY;

    const snapshotSection = DragAndDrop.findBottomSection(
      ev.clientX,
      ev.clientY + DragAndDrop.currentScroll,
    );

    if (
      DragAndDrop.shadowDivData &&
      isCursorInArea({
        cursorX: ev.clientX,
        cursorY: ev.clientY + DragAndDrop.currentScroll,
        bottom: DragAndDrop.shadowDivData?.panelBottom,
        top: DragAndDrop.shadowDivData?.panelTop,
        left: DragAndDrop.shadowDivData?.panelLeft,
        right: DragAndDrop.shadowDivData?.panelRight,
      })
    ) {
      return;
    }

    if (DragAndDrop.currentBottomPanel && snapshotSection) {
      const bottomPanel = DragAndDrop.splash.querySelector(
        `[data-panel][data-id='${DragAndDrop.currentBottomPanel.id}']`,
      );
      const draggingPanel = DragAndDrop.splash.querySelector(
        `[data-panel][data-id='${DragAndDrop.draggingPanelId}']`,
      );
      const bottomSection = DragAndDrop.splash.querySelector(
        `[data-locationid='${snapshotSection.sectionId}']`,
      );

      if (bottomSection) {
        if (
          isCursorInArea({
            cursorX: ev.clientX,
            cursorY: ev.clientY + DragAndDrop.currentScroll,
            ...getColumnAreas({
              ...DragAndDrop.currentBottomPanel,
              panelLeft: bottomSection?.getBoundingClientRect().left ?? 0,
              panelRight: bottomSection?.getBoundingClientRect().right ?? 0,
            }).top,
          })
        ) {
          if (draggingPanel) {
            draggingPanel.setAttribute('style', 'display: none; height: 0;');
          }
          if (bottomPanel && snapshotSection) {
            if (bottomSection) {
              DragAndDrop.shadowDiv.setAttribute('style', 'opacity: 50%;');
              DragAndDrop.debounceBefore(
                bottomPanel,
                DragAndDrop.shadowDiv,
                bottomSection as HTMLElement,
              );
              DragAndDrop.snapshot();
              DragAndDrop.clearTimeout();
            }
          }
        } else if (
          isCursorInArea({
            cursorX: ev.clientX,
            cursorY: ev.clientY + DragAndDrop.currentScroll,
            ...getColumnAreas({
              ...DragAndDrop.currentBottomPanel,
              panelLeft: bottomSection?.getBoundingClientRect().left ?? 0,
              panelRight: bottomSection?.getBoundingClientRect().right ?? 0,
            }).bottom,
          })
        ) {
          const bottomPanel = DragAndDrop.splash.querySelector(
            `[data-panel][data-id='${DragAndDrop.currentBottomPanel.id}']`,
          );
          const draggingPanel = DragAndDrop.splash.querySelector(
            `[data-panel][data-id='${DragAndDrop.draggingPanelId}']`,
          );
          if (draggingPanel) {
            draggingPanel.setAttribute('style', 'display: none;');
          }
          if (bottomPanel && snapshotSection) {
            const bottomSection = DragAndDrop.splash.querySelector(
              `[data-locationid='${snapshotSection.sectionId}']`,
            );
            if (bottomSection) {
              DragAndDrop.shadowDiv.setAttribute('style', 'opacity: 50%;');
              DragAndDrop.debounceAfter(DragAndDrop.shadowDiv, bottomPanel);
              DragAndDrop.snapshot();
              DragAndDrop.clearTimeout();
            }
          }
        }
      }
    } else if (!DragAndDrop.currentBottomPanel && snapshotSection) {
      const bottomSection = DragAndDrop.splash.querySelector(
        `[data-locationid='${snapshotSection.sectionId}']`,
      );
      if (bottomSection) {
        const draggingPanel = DragAndDrop.splash.querySelector(
          `[data-panel][data-id='${DragAndDrop.draggingPanelId}']`,
        );
        if (draggingPanel) {
          draggingPanel.setAttribute('style', 'display: none;');
        }
        DragAndDrop.shadowDiv.setAttribute('style', 'opacity: 50%;');
        DragAndDrop.debounceAppend(
          bottomSection as HTMLElement,
          DragAndDrop.shadowDiv,
        );
        DragAndDrop.snapshot();
        DragAndDrop.clearTimeout();
      }
    }
  }
}
